import * as React from 'react';

import { createStructuredSelector, mconnect } from '../../state/redux';
import { IComponentStateProps, IConnectedComponentProps } from '../../types';
import { dispatchPartnerSolutionRenderedAction } from '../reducers/dispatchers';
import { getNodeSelector } from '../reducers/selectors.redux';
import { ComponentOverrides, ContentType, IPartnerComponentNodeProps } from '../../models';
import { ComponentOverride } from './common/ComponentOverride';

const mapStateToProps = createStructuredSelector({
  node: getNodeSelector
});

const mapDispatchToProps = { dispatchPartnerSolutionRenderedAction };

type IPartnerNodeProps = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps &
  IConnectedComponentProps &
  IComponentStateProps;

class PartnerNodeC extends React.PureComponent<IPartnerNodeProps> {
  public componentDidMount(): void {
    if (
      !!this.props.callbackHandlers.PartnerSolutionRendered &&
      typeof this.props.callbackHandlers.PartnerSolutionRendered === 'function'
    ) {
      this.props.dispatchPartnerSolutionRenderedAction(
        this.props.node,
        this.props.callbackHandlers.PartnerSolutionRendered,
        this.props.callbackHandlers.LogHandler
      );
    }
  }

  public render = (): React.ReactNode => {
    const solutionType: string = this.props.node.get('text').get('contentType');
    const solutionId: string = this.props.node.get('text').get('content');
    const nodeId: string = this.props.node.get('id');
    const uId: string = this.props.node.get('uId');
    const dialogId: string = this.props.node.get('dialogId');
    return (
      <ComponentOverride
        componentName={ComponentOverrides.PartnerSolution}
        callbackHandlers={this.props.callbackHandlers}
        solutionId={solutionId}
        nodeId={nodeId}
        solutionType={solutionType}
        dialogId={dialogId}
        uId={uId}
      />
    );
  };
}

export const PartnerNode = mconnect(mapStateToProps, mapDispatchToProps)(PartnerNodeC);
